export const HUBDB_DATA_SOURCE_TYPE = 1;
export const CRM_DATA_SOURCE_TYPE = 2;
export const HUBDB_REGEX = /hubdb-(\w+)-(\d+)-(\d+)/;
export const CRM_DYNAMIC_PAGE_REGEX = /crm-(\w+)-(\d+)-(\d+)-(\d+)/;